<template>
	<div>
		 <vue-headful
				title="Novedades"
				description="Entérate de las últimas novedades acerca de VARELAB."
			/>

		<div class="front front--page">
			<div v-parallax="0.1" v-parallax.centerX class="bg-parallax bg-parallax--novedades"></div>
			<div class="container">
				<h1 class="title title--big color--white">Novedades</h1>
				<div class="separator separator--white"></div>
			</div>
		</div>
		
		<div class="page-body">
			<div class="container">
				<div class="feed feed--transparent">
					<div v-if="showPosts" v-cloak>
						<div class="row" v-for="i in Math.ceil(posts.length / 3)">
							<div class="col-sm-4" v-for="post in posts.slice((i - 1) * 3, i * 3)">
								<a :href="post.link" class="feed__block" target="_blank">
									<div class="feed__image hidden" :style="{ backgroundImage: 'url(\'' + post.image + '\')' }"></div>
									<img :src="post.image" alt="Novedades Varelab" class="img-responsive">
									<div class="feed__content feed__content--inverse">
										<p v-html="post.title"></p>
										<hr>
									</div>
								</a>
							</div>
						</div>
					</div>
					<div v-else>
						Cargando ...
					</div>
				</div>    
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'servicios',
	data() {
		return {
			posts: false,
			showPosts: false
		}
	},
	beforeRouteEnter (to, from, next) {
		// Hacemos el fetch de la informacion del feed antes de cargar la ruta
		next( vm => vm.getPosts() );
	},
	methods: {
		getPosts: function() {
			this.$http.get('http://www.varelab.com.ar/api/public/api/feed/facebook/6').then(function(response) {
				this.posts = response.data;
				this.showPosts = true;
			});
		}
	},
	// created() {
	// 	this.getPosts();
	// }
}
</script>
<!-- styling for the component -->
<style>

</style>


// WEBPACK FOOTER //
// src/components/Novedades.vue